import { ValidationResult } from './types';

export function isRequired(input: string): ValidationResult {
  return [input.length !== 0, 'Field is required'];
}
